import { FC } from 'react'

import { LoadingIcon } from 'components/shared/Icons'

type LoadingScreenProps = {
  isLoading?: boolean
}

const LoadingScreen: FC<LoadingScreenProps> = ({ isLoading = true }) => {
  return (
    <>
      {isLoading ? (
        <div>
          <div className='bg-white/80 fixed inset-0 z-top'></div>
          <div
            className='backdrop flex flex-col items-center justify-center'
            style={{ zIndex: 9999 }}
          >
            <span className='text-4xl text-primary-purple animate-spin'>
              <LoadingIcon />
            </span>
            <span className='text-primary-purple font-semibold mt-8'>
              Loading...
            </span>
          </div>
        </div>
      ) : null}
    </>
  )
}

const PageLoading: FC = () => {
  return (
    <div className='relative w-full h-[var(--content-height)] flex items-center justify-center'>
      <span className='animate-spin relative inline-block text-4xl text-primary-purple'>
        <LoadingIcon />
      </span>
    </div>
  )
}

export default LoadingScreen
export { PageLoading }
